import { useEffect, useState } from 'react';
// for meta tags
import { Helmet } from 'react-helmet-async';
// components
import Playgrounds from '../../components/Playgrounds/Playgrounds';
import Head from '../../components/UI/Head/Head';
import { ToastContainer } from 'react-toastify';

// style
import style from './arena.module.css';

const Arena = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden'; // Отключаем скролл при загрузке

    const timer = setTimeout(() => {
      setLoading(false);
      document.body.style.overflow = 'visible'; // Возвращаем скролл после загрузки
    }, 300); // 1 секунда для имитации загрузки

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'visible'; // На случай размонтирования компонента
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Площадки для Лазертага Гидробола и Пейнтбола в Казани | Sparta
        </title>
        <meta
          name="description"
          content="Выбирайте лучшие площадки для лазертага, пейнтбола и гидробола от Sparta Kazan. Удобное расположение, современные арсенал."
        />
      </Helmet>
      {loading ? (
        <div className="loaderWrapper">
          <div className="loaderPage"></div>
        </div>
      ) : (
        <main className={style.main}>
          <Head url="/" />
          <div className="container">
            <div className="title-h1">
              <h1>Наши Площадки</h1>
            </div>
          </div>
          <Playgrounds />
          <ToastContainer />
        </main>
      )}
    </>
  );
};
export default Arena;
